import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { SetSelectedBatchFlow } from './actions';

@State({
	name: 'inventoryShared',
	defaults: {}
})

@Injectable()
export class InventorySharedState {

	@Action(SetSelectedBatchFlow, { cancelUncompleted: true })
	onSetSelectedBatchFlow(
		{ setState, getState }: StateContext<any>,
		{ batchFlow }: SetSelectedBatchFlow
	) {
		setState({
			...getState(),
			selectedBatchFlow: batchFlow
		})
	}

}
